import React, { Component } from 'react';
import DayPicker, { DateUtils } from 'react-day-picker';

class Calendar extends Component {
  constructor(props) {
    super(props);
    this.handleDayClick = this.handleDayClick.bind(this);
    this.handleDayMouseEnter = this.handleDayMouseEnter.bind(this);
    this.handleResetClick = this.handleResetClick.bind(this);
    this.handleInputFocus = this.handleInputFocus.bind(this);
    this.state = this.getInitialState();
    this.closeModal = this.closeModal.bind(this);
  }

  getInitialState() {
    return {
      from: null,
      to: null,
      enteredTo: null, // Keep track of the last day for mouseEnter.
    };
  }

  state = {
    showCalendar: false,
    hideCalendar: false,
    mobileDateFrom: '',
    mobileDateTo:'',
  }

  handleInputFocus = (e) => {
    this.setState ({
      showCalendar: true,
      hideCalendar: false,
      dateValue: '',
    })
  }

  closeModal = (e) => {
    this.setState ({
      showCalendar: false
    })
  }

  isSelectingFirstDay(from, to, day) {
    const isBeforeFirstDay = from && DateUtils.isDayBefore(day, from);
    const isRangeSelected = from && to;
    return !from || isBeforeFirstDay || isRangeSelected;
  }

  handleDayClick(day) {
    const { from, to } = this.state;

    if (from && to && day >= from && day <= to) {
      this.handleResetClick();
      return;
    }

    if (this.isSelectingFirstDay(from, to, day)) {
      this.setState({
        from: day,
        to: null,
        enteredTo: null,
      });
    }

    else {
      let selectedDate;
      if ( from && day ) {
        selectedDate = from.toLocaleDateString("en-GB", {day: "numeric", month: "short"}) + " - " + day.toLocaleDateString("en-GB", {day: "numeric", month: "short"});
        this.setState({
          hideCalendar: true,
          showCalendar: false
        })

        const timeDiff  = (new Date(day)) - (new Date(from));
        const nbdays  = timeDiff / (1000 * 60 * 60 * 24)
        let dateObj = {
          frommonth : new Date(from).getMonth() + 1,
          fromday : new Date(from).getDate(),
          fromyear: new Date(from).getFullYear(),
          tomonth : new Date(day).getMonth() + 1,
          dayto : new Date(day).getDate(),
          toyear: new Date(day).getFullYear(),
          nbdays : nbdays,
        }
        this.props.setCalendarData(dateObj);
      }
      this.setState({
        to: day,
        enteredTo: day,
        dateValue: selectedDate,
      });
    }
  }

  handleDayMouseEnter(day) {
    const { from, to } = this.state;
    if (!this.isSelectingFirstDay(from, to, day)) {
      this.setState({
        enteredTo: day,
      });
    }
  }

  handleResetClick() {
    this.setState(this.getInitialState());
  }
  handleClickOutside = event => {
    event.target.classList.forEach(function(e) {
     if(!e.split('-').includes("DayPicker") && !e.split('-').includes("dates") && !e.split('-').includes("calendar")) {
      this.setState({
        showCalendar: false
      })
     }
    }.bind(this))
  }
  componentDidMount = () => {
    document.addEventListener('click', this.handleClickOutside);
  }

  render() {
    const { from, to, enteredTo } = this.state;
    const modifiers = { start: from, end: enteredTo };
    const disabledDays = { before:  new Date() };
    const selectedDays = [from, { from, to: enteredTo }];
    const {
      state: {
        showCalendar,
      }
    } = this;
    const {
      state: {
        dateValue,
      }
    } = this;

    let calendarContent;
    calendarContent =  <DayPicker
      className="Range DayPicker-input-box"
      dayPickerProps={{ disabledDays: {before: new Date()} }}
      numberOfMonths={2}
      keepFocus={false}
      fromMonth={from}
      selectedDays={selectedDays}
      disabledDays={disabledDays}
      modifiers={modifiers}
      onDayClick={this.handleDayClick}
      onDayMouseEnter={this.handleDayMouseEnter}
    />

    return (

      <div className={' ' + (this.state.showCalendar ? 'mobile-modal-calendar' : ' ')}>
        <input type="text"
        className="dates DayPicker-input-box"
        onFocus={this.handleInputFocus}
        placeholder={ Drupal.t('Check in - Check out') }
        onChange={this.handleInputFocus}
        value = {this.state.dateValue || ""}
        readOnly
        />
        <span className="calender-icon"></span>
        <div className={'calender-wrapper mobile-modal' + (this.state.hideCalendar ? 'mobile-only' : ' ')}>
          <div className="close-btn mobile-only" onClick={this.closeModal}></div>
          <div className="mobile-info-wrapper mobile-only">
            <div className="check-in">
              { Drupal.t('check-in')}
              <div className="form-mobile">
                <div className="num">
                  {
                    from && to &&
                      `${from.toLocaleDateString("en-GB", {day: "numeric"})}`
                  }
                </div>
                <div className="mnth">
                {
                  from && to &&
                  `${from.toLocaleDateString("en-GB", {month: "short"})} ( ${from.toLocaleDateString("en-GB", {weekday: "short"})})`

                }
                </div>
              </div>
            </div>
            <div className="arrow"></div>
            <div className="check-out">
              { Drupal.t('check-out')}
              <div className="to-mobile">
                <div className="num">
                  {
                    from && to &&
                      `${to.toLocaleDateString("en-GB", {day: "numeric"})}`
                  }
                </div>
                <div className="mnth">
                {
                  from && to &&
                  `${to.toLocaleDateString("en-GB", {month: "short"})} ( ${to.toLocaleDateString("en-GB", {weekday: "short"})})`
                }
                </div>
              </div>
            </div>
          </div>
          {calendarContent}
          <div className="done-button btn--primary mobile-only" onClick={this.closeModal}> {Drupal.t("Done")}</div>
        </div>
      </div>
    );
  }
}

export default Calendar;
